import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GuiFlowService } from '../../../___LOGIC/__gui/gui-flow.service';

@Component({
  selector: 'app-download-zip',
  templateUrl: './download-zip.component.html',
  styleUrls: ['./download-zip.component.css']
})
export class DownloadZipComponent implements OnInit {

  loading = true;
  isPdf = false;
  success = false;
  error = false;
  contractId: string;
  progress = 0;
  countdown = 10;
  countdownInterval: any;
  omnibusContract;
  processStatus;
  downloadCounter = 0;

  constructor(private route: ActivatedRoute,private http: HttpClient,private router: Router,private guiFlow: GuiFlowService) {}

  ngOnInit() {
    this.contractId = this.route.snapshot.paramMap.get('contractId')!;
    const urlSegment = this.route.snapshot.url.map(segment => segment.path).join('/');

    this.http.get('https://app.voyjaleas.com/myapp/get/queryHandler.php?queryId=getOmnibusContractInfo&queryParam1='+this.contractId)
        .subscribe(
          (response) => {
            this.omnibusContract = response['records'];
            this.processStatus = parseInt(this.omnibusContract['status']);
            this.isPdf = urlSegment.startsWith('download-pdf');
            this.isPdf ? this.downloadPdf() : this.downloadZipNew();
          },
          (error) => {
            this.guiFlow.openSimpleSnackBar('Error, por favor contacta con el administrador','error',null,null);
            console.log(error);
          }
      );
  }

  updateContractInfo(p_contractUpdated){
    
    this.http.put('https://app.voyjaleas.com/myapp/put/updateRow.php?table=omnibusContract&id='+this.contractId,p_contractUpdated).subscribe(
        (response) => {
          this.startCountdown();
        },
        (error) => {            
          console.log(error);
        }
    )
  }

  downloadZipNew() {
    const url = `https://app.voyjaleas.com/myapp/fileManager/download-file.php?contractId=${this.contractId}&process=asisaDocs`;
  
    this.http.get(url, {
      responseType: 'blob', // <- this is key
      observe: 'response'   // <- to access filename from headers
    }).subscribe(response => {
      const blob = new Blob([response.body], { type: 'application/zip' });
  
      // Get filename from headers if sent
      const contentDisposition = response.headers.get('Content-Disposition');
      let filename = 'documentos.zip';
      if (contentDisposition && contentDisposition.indexOf('filename=') !== -1) {
        filename = contentDisposition.split('filename=')[1].replace(/"/g, '');
      }
      this.loading = false;
      this.success = true;
      this.downloadCounter++;

      /* const contractUpdated = { status: this.processStatus+1 };
      this.updateContractInfo(contractUpdated); */
      
      // Create download link
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    }, error => {
      console.error('Error downloading ZIP file:', error);
    });
  }
  
  // WIP
  downloadZipNew1() {
    const url = `https://app.voyjaleas.com/myapp/fileManager/download-file.php?contractId=${this.contractId}&process=asisaDocs`;
  
    this.http.get(url, {
      reportProgress: true,
      observe: 'events',
      responseType: 'blob'
    }).subscribe((event: HttpEvent<any>) => {
      if (event.type === HttpEventType.DownloadProgress && event.total) {
        this.progress = Math.round((100 * event.loaded) / event.total);
      } else if (event.type === HttpEventType.Response) {
        const contentDisposition = event.headers.get('Content-Disposition');
        let filename = `documentos-${this.contractId}.zip`;
  
        if (contentDisposition) {
          const matches = /filename="([^"]+)"/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1];
          }
        }
  
        const blob = event.body;
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
  
        this.loading = false;
        this.success = true;
        debugger

/*         const contractUpdated = { status: this.processStatus+1};
        this.updateContractInfo(contractUpdated); */
      }
    }, error => {
      console.error('Download failed', error);
      this.loading = false;
      this.error = true;
    });

  }

  downloadZipWorking() {
    const url = `https://app.voyjaleas.com/myapp/fileManager/download-zip.php?contractId=${this.contractId}`;
  
    this.http.get(url, {
      reportProgress: true,
      observe: 'events',
      responseType: 'blob'
    }).subscribe((event: HttpEvent<any>) => {
      if (event.type === HttpEventType.DownloadProgress && event.total) {
        this.progress = Math.round((100 * event.loaded) / event.total);
      } else if (event.type === HttpEventType.Response) {
        const contentDisposition = event.headers.get('Content-Disposition');
        let filename = `documentos-${this.contractId}.zip`;
  
        if (contentDisposition) {
          const matches = /filename="([^"]+)"/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1];
          }
        }
  
        const blob = event.body;
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
  
        this.loading = false;
        this.success = true;
  
        const contractUpdated = {
          status: 6
        };
  
        this.http.put('https://app.voyjaleas.com/myapp/put/updateRow.php?table=omnibusContract&id=' + this.contractId, contractUpdated)
          .subscribe(
            () => {
              //return this.http.post('https://app.voyjaleas.com/myapp/email/notifyAdmin.php',null).toPromise();
            },
            (error) => {
              console.log(error);
            }
          );
  
        this.startCountdown();
      }
    }, error => {
      console.error('Download failed', error);
      this.loading = false;
      this.error = true;
    });
  }
  
  downloadPdf() {
    const url = `https://app.voyjaleas.com/myapp/fileManager/download-file.php?contractId=${this.contractId}&process=comprobantePdf&format=pdf`;
  
    this.http.get(url, {
      reportProgress: true,
      observe: 'events',
      responseType: 'blob'
    }).subscribe(event => {
      if (event.type === HttpEventType.DownloadProgress && event.total) {
        this.progress = Math.round((100 * event.loaded) / event.total);
      } else if (event.type === HttpEventType.Response) {

        const contentDisposition = event.headers.get('Content-Disposition');
        let filename = `comprobante_${this.contractId}.pdf`;
  
        if (contentDisposition) {
          const matches = /filename="([^"]+)"/.exec(contentDisposition);
          if (matches != null && matches[1]) {
            filename = matches[1];
          }
        }

        const contentType = event.headers?.get('Content-Type');
  
        if (contentType === 'application/pdf') {
          this.triggerDownload(event.body, `${filename}.pdf`, 'application/pdf');
        } else {
          console.error('⚠️ PDF inválido. Contenido recibido:');
        }
      }
    }, error => {
      console.error('❌ Error durante la descarga del PDF', error);
      this.showError();
    });
  }
  
  showError() {
    this.loading = false;
    this.error = true;
  }

  triggerDownload(data: Blob, filename: string, type: string) {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
  
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  
    window.URL.revokeObjectURL(url);
  
    this.loading = false;
    this.success = true;
    this.downloadCounter++;
/*     const contractUpdated = { status: this.processStatus+1 };
    this.updateContractInfo(contractUpdated); */
  }
  
  startCountdown() {
    const endTime = Date.now() + this.countdown * 1000;
    this.countdownInterval = setInterval(() => {
      const remaining = Math.ceil((endTime - Date.now()) / 1000);
      this.countdown = remaining > 0 ? remaining : 0;
  
      if (this.countdown === 0) {
        clearInterval(this.countdownInterval);
        this.goBack();
      }
    }, 1000);
  }
  

  downloadAgain() {
    this.loading = true;
    this.success = false;
    this.error = false;
    this.progress = 0;
    this.isPdf ? this.downloadPdf() : this.downloadZipNew();
  }

  goBack() {
    window.history.back();
  }
}
